import React from 'react';
import PropTypes from 'prop-types';

import AppsListItemSuggestion from './AppsListItemSuggestion';
import AppsListItemSideload from './AppsListItemSideload';
import RenderApps from './RenderApps';

function allApps({ apps }) {
    return (
        <div>
            <div className="appsListItemsWrapper">
                <RenderApps apps={apps} />
                <AppsListItemSuggestion />
                <AppsListItemSideload />
            </div>
        </div>
    );
}

allApps.propTypes = {
    apps: PropTypes.array,
};

export default allApps;
